<template>
    <div class="dev-layout">
        <RouterView />
    </div>
</template>

<script setup lang="ts">
defineOptions({
    name: "DevLayout",
});
</script>

<style scoped>
.dev-layout {
    min-height: 100vh;
    background-color: var(--surface-ground, #f8f9fa);
}
</style>
